import { Injectable, computed, effect, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalScrollService {

  private _isScrolled = signal<boolean>(false);
  readonly isScrolled = this._isScrolled.asReadonly();

  // Computed signals for derived state
  readonly hasScrolled = computed(() => this._isScrolled());
  readonly isAtTop = computed(() => !this._isScrolled());

  // Event stream for scroll events (keep as Subject for event handling)
  private _scrolled$ = new Subject<boolean>();
  scrolled$ = this._scrolled$.asObservable();

  constructor() {
    // Effect to sync signal changes to Subject
    effect(() => {
      const scrolled = this._isScrolled();
      this._scrolled$.next(scrolled);
    });
  }

  scrolled() {
    // Emit directly to Subject to trigger every time, not just on signal change
    this._scrolled$.next(true);
  }

  // Additional methods for better control
  resetScroll() {
    this._isScrolled.set(false);
  }

  setScrollState(state: boolean) {
    this._isScrolled.set(state);
  }

  // Get current scroll state synchronously
  getScrollState(): boolean {
    return this._isScrolled();
  }
}
